import { AdminContainer, AdminComingSoon } from '../AdminShell';

export function AdminPagos() {
  return (
    <AdminContainer title="Pagos" eyebrow="Cobranza">
      <AdminComingSoon
        what="Pagos"
        suggestion="Pagos pendientes, parciales y conciliados. Link a Facturapi para CFDI."
      />
    </AdminContainer>
  );
}
